import React from 'react';
import * as S from './DropDownList.styled';
import { ParagraphWithTooltip, ImageWithFallback } from 'components';
import { Palette } from 'config';
import { subdirectory } from 'utils';

export const AppItem = ({ handleClickOnItem, rowData, isActiveApp, searchValue$ }) => {
  const { image_url, pba_number, containedIn, app, packageName } = rowData;

  return (
    <S.AppItem
      onClick={() => handleClickOnItem(rowData)}
      key={pba_number}
      isActive={isActiveApp(containedIn)}
    >
      <S.ImgBox>
        <ImageWithFallback
          src={`https://cdn.appnext.com/${subdirectory(image_url)}/${image_url}`}
        />
      </S.ImgBox>
      <div style={{ maxWidth: '250px', display: 'flex', flexDirection: 'column' }}>
        <ParagraphWithTooltip
          style={{
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: '20px',
            color: '#0F172A',
          }}
          text={app}
          search={searchValue$.value}
          isHighlight
          highlightStyle={{ color: `${Palette.PrimaryGray._900}`, fontWeight: '500' }}
        />
        <ParagraphWithTooltip
          style={{
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: '16px',
            color: '#64748B',
          }}
          text={packageName.toString() || 'no package name'}
          search={searchValue$.value}
          isHighlight
          highlightStyle={{ color: `${Palette.PrimaryGray._900}`, fontWeight: '500' }}
        />
      </div>
    </S.AppItem>
  );
};
